import './styles.scoped.css'
import {useState} from 'react'
import {Typography, Tabs, Tab} from '@mui/material'
import {PersonalInformation, Preferences, AdditionalInfo} from './components'
import {useMobile} from '../../hooks'

export default () => {
    const [tab, setTab] = useState(0)
    const {mobile} = useMobile()

    return (
        <>
            {!mobile && (
                <>
                    <Typography variant="h6" color="text.primary">
                        Contact Information
                    </Typography>
                    <br />
                    <br />
                </>
            )}
            <Tabs
                value={tab}
                onChange={(e, newValue) => setTab(newValue)}
                allowScrollButtonsMobile
                variant={mobile ? 'scrollable' : 'fullWidth'}
                style={{width: mobile ? 420 : '100%'}}>
                <Tab label="Personal Information" />
                <Tab label="Preferences" />
                <Tab label="Additional Info" />
            </Tabs>
            <br />
            <br />
            <div style={{display: tab != 0 ? 'none' : 'block'}}>
                <PersonalInformation />
            </div>
            <div style={{display: tab != 1 ? 'none' : 'block'}}>
                <Preferences />
            </div>
            <div style={{display: tab != 2 ? 'none' : 'block'}}>
                <AdditionalInfo />
            </div>
        </>
    )
}
